import { render, staticRenderFns } from "./lecture-dialog.vue?vue&type=template&id=c1298de2"
import script from "./lecture-dialog.vue?vue&type=script&lang=js"
export * from "./lecture-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports